<template>
  <v-app>
    <the-sidebar v-if="loggedIn" v-model="drawer" />
    <the-navbar v-if="loggedIn" @toggle-sidebar="drawer = !drawer" />
    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authComputed } from './vuex/helpers.js'
import TheNavbar from './components/layout/TheNavbar.vue'
import TheSidebar from './components/layout/TheSidebar.vue'

export default {
  name: 'App',
  components: {
    TheNavbar,
    TheSidebar
  },
  data() {
    return {
      drawer: null
    }
  },
  computed: {
    ...authComputed
  }
}
</script>

<style>
h1 {
  font-weight: bold;
  font-size: 16px;
}
h2 {
  font-weight: bold;
  font-size: 14px;
}
.page-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
